import { AutoAwesome, Logout } from "@mui/icons-material";
import { useAuth } from "react-oidc-context";
import { COGNITO_CLIENT_ID, COGNITO_DOMAIN } from "../../../../config/configCognito";
import { Grid, IconButton, Typography } from "../../basics";
import { StyledAssistentButton } from "./styled";
import { IAssistentButtonProps } from "./types";
const { REACT_APP_BASE_WEB_URL } = process.env;

const AssistentButton = (props: IAssistentButtonProps) => {
    const signOutRedirect = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        sessionStorage.clear();
        localStorage.clear();
        const clientId = COGNITO_CLIENT_ID;
        const logoutUri = `${REACT_APP_BASE_WEB_URL}/`;
        const cognitoDomain = COGNITO_DOMAIN;
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
      };
    const auth = useAuth();

    const removeOutLogout = () => {
        auth.removeUser();
        auth.signoutRedirect({
            post_logout_redirect_uri: "http://localhost:3000/login",
        });
    }
    return (
        <StyledAssistentButton>
            <Grid container gap={2} onClick={props.onClick} alignItems="center">
                <IconButton
                    variant="clean"
                    color="secondary"
                    onClick={signOutRedirect}
                >
                    <Logout/>
                </IconButton>
                <AutoAwesome />
                <Typography variant='body1'>
                    Assistente Virtual
                </Typography>
            </Grid>
        </StyledAssistentButton>
    )
}

export { AssistentButton };
